import { Placeholder } from '../Placeholder';
export default function SignalForecastPage(): JSX.Element {
  return <Placeholder screenNo="3" title="단기/중기/장기 지표 예측" description="타임프레임별 신호·ML 현황·섹터 스코어." />;
}
